import { EPermissions, PERMISSIONS } from '@/types/permissions.types';

export const rolePermissionSortOrder = {
  [PERMISSIONS.Admin]: 1,
  [PERMISSIONS.GroupAdmin]: 2, // Folder Manager
  [PERMISSIONS.Editor]: 3,
  [PERMISSIONS.Moderation]: 5, // Moderator
  [PERMISSIONS.Analytics]: 5, // Analyst
  [PERMISSIONS.Producer]: 6,
  [PERMISSIONS.Builder]: 7, // Developer
};

export const allAccessRoles = [EPermissions.Owner, EPermissions.Admin, EPermissions.Builder];

// Role hierarchy for who is allowed to add/remove access
const ACCESS_EDIT_ROLE_RANK: Partial<Record<EPermissions, number>> = {
  [EPermissions.GroupAdmin]: 1,
  [EPermissions.Editor]: 2,
  [EPermissions.Moderation]: 2,
  [EPermissions.Analytics]: 2,
  [EPermissions.Producer]: 2,
  [EPermissions.PasscodeManager]: 2,
  [EPermissions.Viewer]: 3,
};

// A user's effective rank is their most senior role.
const mostSeniorAccessEditRank = (roles: EPermissions[]): number | null => {
  const ranks = roles.map((role) => ACCESS_EDIT_ROLE_RANK[role]).filter((rank): rank is number => rank !== undefined);

  return ranks.length ? Math.min(...ranks) : null;
};

// A viewer may only add/remove project access for a target strictly lower in the role hierarchy than themselves
export const isTargetSameOrHigherRank = (targetRoles: EPermissions[], viewerRoles: EPermissions[]): boolean => {
  const targetRank = mostSeniorAccessEditRank(targetRoles);
  const viewerRank = mostSeniorAccessEditRank(viewerRoles);

  if (targetRank === null || viewerRank === null) {
    return true;
  }

  return targetRank <= viewerRank;
};
